export const omit = <T extends object, K extends [...(keyof T)[]]>(
  obj: T,
  ...keys: K
): Exclude<T, K> => {
  const ret = {} as T;
  let key: keyof typeof obj;
  // eslint-disable-next-line no-restricted-syntax
  for (key in obj) {
    if (!keys.includes(key)) {
      ret[key] = obj[key];
    }
  }
  return ret as Exclude<T, K>;
};
